/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Rental car dropoff location details — counter, address, and shuttle info at the return facility
 * @export
 * @interface DropoffLogistics
 */
export interface DropoffLogistics {
    /**
     * Counter location description from the vendor at the return facility (e.g., "Terminal 1, Level 1")
     * @type {string}
     * @memberof DropoffLogistics
     */
    counterLocation?: string;
    /**
     * Shuttle service details for the dropoff location if applicable
     * @type {string}
     * @memberof DropoffLogistics
     */
    shuttleInfo?: string;
    /**
     * Street address of the dropoff facility
     * @type {string}
     * @memberof DropoffLogistics
     */
    address?: string;
    /**
     * Phone number for the dropoff location
     * @type {string}
     * @memberof DropoffLogistics
     */
    phone?: string;
}

/**
 * Check if a given object implements the DropoffLogistics interface.
 */
export function instanceOfDropoffLogistics(value: object): value is DropoffLogistics {
    return true;
}

export function DropoffLogisticsFromJSON(json: any): DropoffLogistics {
    return DropoffLogisticsFromJSONTyped(json, false);
}

export function DropoffLogisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropoffLogistics {
    if (json == null) {
        return json;
    }
    return {
        
        'counterLocation': json['counter_location'] == null ? undefined : json['counter_location'],
        'shuttleInfo': json['shuttle_info'] == null ? undefined : json['shuttle_info'],
        'address': json['address'] == null ? undefined : json['address'],
        'phone': json['phone'] == null ? undefined : json['phone'],
    };
}

export function DropoffLogisticsToJSON(json: any): DropoffLogistics {
    return DropoffLogisticsToJSONTyped(json, false);
}

export function DropoffLogisticsToJSONTyped(value?: DropoffLogistics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'counter_location': value['counterLocation'],
        'shuttle_info': value['shuttleInfo'],
        'address': value['address'],
        'phone': value['phone'],
    };
}

